angular
  .module("app.views")
  .controller(
    "TicketsRefundFormController",
    function (
      $scope,
      tickets,
      broadcast,
      channel,
      account,
      Ticket,
      ChannelTicket,
      $modalInstance,
      $q
    ) {
      const CONCURRENCY_LIMIT = 6;
      $scope.tickets = tickets;
      $scope.broadcast = broadcast;
      $scope.account = account;
      $scope.channel = channel;
      $scope.confirmRefund = {
        confirm: false,
      };
      $scope.totalRefund = $scope.tickets.length * $scope.tickets[0].price;

      $scope.ok = function () {
        $scope.loading = true;
        $scope.isRefunding = true;
        let d = $q.defer();
        $scope
          .refundInBatches($scope.tickets)
          .then((result) => {
            d.resolve(result);
            $modalInstance.close();
          })
          .catch((err) => {
            d.reject(err);
          });
      };

      $scope.refundInBatches = function (tickets) {
        return $q((resolve, reject) => {
          const refundQuery = function (remaining) {
            let chunk = remaining.slice(0, CONCURRENCY_LIMIT);
            let leftover = remaining.slice(CONCURRENCY_LIMIT);
            let promises = [];
            _.forEach(chunk, (c) => {
              if ($scope.broadcast) {
                promises.push(
                  Ticket.refund({ broadcast_id: c.broadcast_id, id: c.id })
                    .$promise
                );
              }
              if ($scope.channel) {
                promises.push(
                  ChannelTicket.refund({ channel_id: c.channel_id, id: c.id })
                    .$promise
                );
              }
            });

            $q.all(promises)
              .then((result) => {
                if (leftover.length <= 0) {
                  resolve(result);
                } else {
                  refundQuery(leftover);
                }
              })
              .catch((err) => {
                reject(err);
              });
          };
          refundQuery(tickets);
        });
      };

      return ($scope.cancel = () => $modalInstance.dismiss("cancel"));
    }
  );



// WEBPACK FOOTER //
// ./views/broadcast/tickets_refund_form_controller.js